import React from 'react';
import clsx from 'clsx';
import VuiNumberFormat from '../../../../../vodea/@vodea-ui/components/VuiNumberFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';

const ProductItem: React.FC<any> = ({ product, onClick }) => {
  return (
    <div className={clsx({
      'product-item': true,
      'empty': product?.quantity === 0,
    })} onClick={() => {
      if (product?.quantity > 0 && onClick) {
        onClick();
      }
    }}>
      <div className='product-item-overlay'>
        <div className='overlay-content'>
          <span className='icon'>+</span>
          Add Item
        </div>
      </div>
      <div className='product-item-empty-overlay'>
        <div className='overlay-content'>
          <FontAwesomeIcon icon={faBoxOpen} className={'icon icon-prefix'} />
          <div>Product Empty</div>
        </div>
      </div>
      <div
        className={clsx({
          'product-item-image': true,
          empty: !product.photo_url
        })}
      >
        <img src={product.photo_url ?? '/icons/default-empty-image.svg'} alt={product.name} />
      </div>
      <div className='product-item-details'>
        <div className='product-item-name'>{product.name}</div>
        <div className='product-item-info'>
          <div className='product-item-price'>
            <VuiNumberFormat prefix="IDR " data={product.default_price} />
          </div>
          <div className='product-item-stock'>
            <VuiNumberFormat suffix={` ${product?.unit_code}`} data={product.quantity} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;